import { jsx } from 'react/jsx-runtime';
import { useSwitch } from '../../Switch.hooks.js';
import { Slot } from '../Slot/Slot.js';

function RightSlot(props) {
  const {
    checked
  } = useSwitch();
  return jsx(Slot, {
    ...props,
    checked: checked
  });
}

export { RightSlot };
